import api from "./api";

export const userApi = {
  updatePassword: async (oldPassword: string, newPassword: string) => {
    return api.put("/user/me/password", { oldPassword, newPassword });
  },

  updateUsername: async (username: string) => {
    return api.put("/user/me/username", { username });
  },

  updateEmail: async (email: string) => {
    return api.put("/user/me/email", { email });
  },

  updateDetails: async (vorname: string, nachname: string) => {
    return api.put("/user/me/details", { vorname, nachname });
  },
};
